import { Skeleton } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

export const AdminTableLoader = () => {
	return (
		<div className={styles.admin_table_loader}>
			<div className={styles.admin_table_loader__main}>
				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '22px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '36px', height: '36px' }} />
				</div>

				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '186px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '537px', height: '44px' }} />
				</div>

				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '186px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '485px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
				</div>

				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '186px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '485px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
				</div>
				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '186px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '485px', height: '44px' }} />
					<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
				</div>
				<div>
					<Skeleton style={{ maxWidth: '234px', height: '44px' }} />
				</div>
			</div>

			<div>
				<Skeleton style={{ maxWidth: '207px', height: '44px' }} />
			</div>

			<div className={styles.admin_table_loader__footer}>
				<Skeleton style={{ maxWidth: '322px', height: '36px' }} />
				<Skeleton style={{ maxWidth: '64px', height: '36px' }} />
			</div>
		</div>
	);
};
